import { React, useState } from 'react'
// import Advices from './Advices'
import Cbsecard from './Cbsecard'
import Semester from './Semester'
import Footer from './Footer'
import Heading from './Heading'
import Navbar from './Navbar'
import Scrolling from './Scrolling'
import Selectbranch from './Selectbranch'
import Subjects from './Subjects'
import Downloadpage from './Downloadpage'
import About from './About'
import Contactus from './Contactus'
import Alert from './Alert'
import Developers from './Developers'

function Home() {

   const [Display, setDisplay] = useState("Home");
   const [Branch, setBranch] = useState("");
   const [semNumber, setsemNumber] = useState('')
   const [Subject, setSubject] = useState("")
   const [version] = useState("v.2.0")

   let currentDisplay;
   let navbar = <Navbar setDisplay={setDisplay} ver={version} key={"nav"} />
   let heading = <Heading key={"head"} />
   let scrolling = <Scrolling key={"scroll"} setDisplay={setDisplay} />
   let cbsecard = <Cbsecard key={"cbse"} />
   let SelectBranch = <Selectbranch setDisplay={setDisplay} setBranch={setBranch} key={"Sbranch"} />
   let semester = <Semester Branch={Branch} setDisplay={setDisplay} setsemNumber={setsemNumber} key={"Ssemester"} />
   let subjects = <Subjects Branch={Branch} semNumber={semNumber} setDisplay={setDisplay} setSubject={setSubject}  key={"Ssubject"} />
   let downloadPage = <Downloadpage Branch={Branch} semNumber={semNumber} Subject={Subject} setDisplay={setDisplay} key={"downloadPg"} />
   // let advices = <Advices setDisplay={setDisplay} key={"advices"}/>
   let about = <About key={"aboutUS"} />
   let contactUs = <Contactus setDisplay={setDisplay} key={"contactForm"} />
   let footer = <Footer setDisplay={setDisplay} key={"footer"} />
   let alert = <Alert key={"alert"} />
   let developers = <Developers key={"developers"} />
   if (Display === "Home") {
      let array_disp = [navbar, alert, heading, scrolling, cbsecard, SelectBranch, contactUs, developers, footer]
      currentDisplay = array_disp;
   }
   if (Display === "Semester") {
      let array_disp = [navbar, semester, footer]
      currentDisplay = array_disp;
   }
   if (Display === "Branch") {
      let array_disp = [navbar, SelectBranch, footer]
      currentDisplay = array_disp;
   }
   if (Display === "Subject") {
      let array_disp = [navbar, subjects, footer]
      currentDisplay = array_disp;
   }
   if (Display === "DownloadPg") {
      let array_disp = [navbar, downloadPage, footer]
      currentDisplay = array_disp;
   }
   if (Display === "About") {
      let array_disp = [navbar, about, footer]
      currentDisplay = array_disp;
   }



   // Stop user to Inspect, save or open developer options
   window.addEventListener("keydown", (event) => {
      if (event.ctrlKey && (event.key === "S" || event.key === "s")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }

      if (event.ctrlKey && (event.key === "C")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }
      if (event.ctrlKey && (event.key === "E" || event.key === "e")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }
      if (event.ctrlKey && (event.key === "I" || event.key === "i")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }
      if (event.ctrlKey && (event.key === "K" || event.key === "k")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }
      if (event.ctrlKey && (event.key === "U" || event.key === "u")) {
         event.preventDefault();
         window.alert("Sorry, This Operation is not allowed.");
      }
   });
   // stop right click
   document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
   });

   return (
      <div className='bg-color-theme' >
         {currentDisplay}
      </div>
   )
}

export default Home;